import * as yup from 'yup'
import { firstNameField, lastNameField } from '../../../../fields/name'
import {
  homePhoneMessage,
  personalEmailMessage,
  personalEmailLengthMessage
} from '../../../../strings/messages'
import { phoneRegex } from '../../../../strings/regex'
import { firstNameYup, lastNameYup } from '../../../../validators'

export const contactInfo = {
  id: 'contact_information',
  title: 'Your contact information',
  description:
    'You are not required to provide your contact information. However, providing your contact information allows us to follow up if necessary.',
  validation: yup.object().shape({
    first_name: firstNameYup(false),
    last_name: lastNameYup(false),
    phone: yup.string().matches(phoneRegex, {
      message: homePhoneMessage,
      excludeEmptyString: true
    }),
    email: yup
      .string()
      .email(personalEmailMessage)
      .max(250, personalEmailLengthMessage)
  }),
  fields: [
    firstNameField,
    lastNameField,
    {
      type: 'text',
      name: 'phone',
      label: 'Phone'
    },
    {
      type: 'text',
      label: 'Email',
      name: 'email'
    }
  ]
}
